/* =========================================================
   BlackishGear — Home custom sections shared behaviour.
   Kept as small, independent, idempotent init functions so
   each blackish-*.liquid section can include this one file
   and only the relevant piece of it does anything.
   ========================================================= */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollCue() {
    var cues = document.querySelectorAll('[data-blackish-scroll-cue]');
    if (!cues.length) return;

    cues.forEach(function (cue) {
      cue.addEventListener('click', function () {
        var target = cue.closest('.blackish-hero');
        if (!target) return;
        var next = target.nextElementSibling;
        if (next) {
          next.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
  }

  function initRails() {
    var rails = document.querySelectorAll('[data-blackish-rail]');
    if (!rails.length) return;

    rails.forEach(function (rail) {
      var track = rail.querySelector('[data-blackish-rail-track]');
      var prevBtn = rail.parentElement.querySelector('[data-blackish-rail-prev]');
      var nextBtn = rail.parentElement.querySelector('[data-blackish-rail-next]');
      if (!track) return;

      function step() {
        var slide = track.querySelector('.blackish-rail__slide');
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
        var width = slide ? slide.getBoundingClientRect().width : track.clientWidth;
        return width + gap;
      }

      function updateButtons() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: prefersReducedMotion ? 'auto' : 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: prefersReducedMotion ? 'auto' : 'smooth' });
        });
      }

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  function init() {
    initScrollCue();
    initRails();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
